import { render, staticRenderFns } from "./InvestorsModule.vue?vue&type=template&id=478242af&scoped=true"
import script from "./InvestorsModule.vue?vue&type=script&lang=js"
export * from "./InvestorsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478242af",
  null
  
)

export default component.exports